import { Button as Button_ } from "@chakra-ui/react";
import { forwardRef } from "react";

import { ButtonGroup as ButtonGroup_ } from "@chakra-ui/react";
export const Button = forwardRef(({ ...props }, ref) => {
    return <Button_ ref={ref} {...props}>{props?.children}</Button_>
});
export const ButtonGroup = forwardRef(({ ...props }, ref) => {
    return <ButtonGroup_ ref={ref} {...props}>{props?.children}</ButtonGroup_>
});